import * as gtm3Map from '@/constants/gtm'
import * as gtm4Map from '@/constants/gtm4'
import * as gtm4AabMap from '@/constants/gtm4-aab'
import { analyticsFactory } from '@accor/customer-vue-services'
import TagManager from '@accor/core-services/src/gtm'

TagManager.initDefaultAutoTracking()

export const { getGtmId, trackPage, trackEventByGtmMap, trackEvent, trackingDirective } =
  analyticsFactory({ gtm4Map: { ...gtm4Map, ...gtm4AabMap }, gtm3Map })
